<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>基础数据</el-breadcrumb-item>
        <el-breadcrumb-item>科目管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">科目管理</h2>
        </div>
        <div class="right">
          <el-button class="button" type="primary" @click="handleToCategory"
            >分类管理</el-button
          >
          <el-button class="button" type="primary" @click="handleSubjectCreate"
            >添加科目</el-button
          >
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="科目名称" prop="subject">
          <el-input
            v-model="query.subject"
            placeholder="输入科目名称/代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="院校名称" prop="college">
          <el-input
            v-model="query.college"
            placeholder="输入院校名称/代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="category_id">
          <el-select v-model="query.category_id" placeholder="请选择">
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统考" prop="type">
          <el-select v-model="query.type" placeholder="请选择">
            <el-option
              v-for="item in filter.types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="query.status" placeholder="请选择">
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table class="table" :data="results" border style="width: 100%">
          <el-table-column prop="id" label="ID" width="80" align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="科目名称"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="code"
            label="科目代码"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="category_id"
            label="科目分类"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              {{ renderCategoryName(scope.row.category_id) }}
            </template>
          </el-table-column>
          <el-table-column label="统考" width="160" align="center">
            <template slot-scope="scope">
              {{ scope.row.type == 1 ? "统考" : "非统考" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="院校名称"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="college_code"
            label="院校代码"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column label="状态" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{
                scope.row.status == 1 ? "正常" : "下线"
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToSubjectEdit(scope.row, scope.$index)"
                >编辑</el-button
              >
              <!-- <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToSubjectRemove(scope.row, scope.$index)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <SubjectCreate
      :visible="createDialog"
      @close="createDialog = false"
      @submit="fetchSubjectList"
    ></SubjectCreate>
    <SubjectEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog = false"
      @submit="fetchSubjectList"
    ></SubjectEdit>
  </div>
</template>

<script>
import SubjectCreate from "@/components/dialog/subject/SubjectCreate";
import SubjectEdit from "@/components/dialog/subject/SubjectEdit";
import { subjectList, subjectDestroy, subjectCategoryList } from "@/api/common";

export default {
  components: {
    SubjectCreate,
    SubjectEdit,
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      query: {
        subject: "",
        status: "",
        category_id: "",
        type: "",
        province_code: "",
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
        major_code: "065100",
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "正常", value: "1" },
          { label: "关闭", value: "0" },
        ],
        types: [
          { label: "全部", value: "" },
          { label: "统考", value: "1" },
          { label: "非统考", value: "0" },
        ],
      },
      categorys: [],
      results: [],
    };
  },
  created() {
    this.parseQuery();
    this.fetchCategoryList();
    this.fetchSubjectList();
  },
  methods: {
    // 分类列表请求
    fetchCategoryList() {
      subjectCategoryList({ isPaging: 0 }).then((res) => {
        let list = res.list;
        list.unshift({ id: "", name: "全部" });
        this.categorys = res.list;
      });
    },
    // 科目列表请求
    fetchSubjectList() {
      subjectList(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    renderCategoryName(id) {
      if (!id) {
        return "";
      }
      const list = this.categorys.filter((item) => item.id == id);
      if (list.length) {
        return list[0].name;
      }
      return "";
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchSubjectList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchSubjectList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchSubjectList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchSubjectList();
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: "正常",
        2: "关闭",
      };
      if (type == "status") {
        return status[value] || "";
      }
      return "";
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/subject/category`);
    },
    // 科目创建
    handleSubjectCreate() {
      this.createDialog = true;
    },
    // 科目编辑
    handleToSubjectEdit(row) {
      this.editRow = Object.assign({}, row, {
        status: row.status == 1 ? true : false,
      });
      this.editDialog = true;
    },
    // 科目删除
    handleToSubjectRemove(row) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          subjectDestroy({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`);
            this.fetchSubjectList();
          });
        })
        .catch(() => {});
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
  },
};
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
